module.exports = __webpack_public_path__ + "static/media/android-icon-96x96.b85a9e57.png";